import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <div className="auth-shell">
      <header className="auth-shell__topbar">
        <Link to="/" className="auth-shell__logo">
          <img src="/assets/img/wordmark-light.svg" alt="Rival Prop Firm" className="auth-shell__logo--light" />
          <img src="/assets/img/wordmark-dark.svg" alt="Rival Prop Firm" className="auth-shell__logo--dark" />
        </Link>
        <Link to="/help" className="auth-shell__help">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <circle cx="12" cy="12" r="9" />
            <path d="M9.5 9 a2.5 2.5 0 1 1 3.5 2.3 c-0.7 0.3 -1 0.7 -1 1.7 M12 17 v0" />
          </svg>
          Need help?
        </Link>
      </header>

      <main className="auth-shell__main">{children}</main>

      <footer className="auth-shell__footer">
        <span>© 2026 Rival Prop Firm</span>
        <div className="auth-shell__footer-links">
          <Link to="/risk-disclosure" className="auth-shell__footer-link">Risk Disclosure</Link>
          <Link to="/system-status" className="auth-shell__footer-link">Status</Link>
        </div>
      </footer>
    </div>
  )
}

export function ArrowRightIcon({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12 h14 M13 5 l7 7 -7 7" />
    </svg>
  )
}
